import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';


@Component({
    selector: 'app-bar-line-chart',
    templateUrl: './bar-line-chart.component.html',
    styleUrls: ['./bar-line-chart.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BarLineChartComponent {

  @Input() data;

  ngAfterViewInit() {
     this.showGraph();
  }
  showGraph() {
    const margin = { top: 30, right: 40, bottom: 40, left: 40 };
    const width = 800 - margin.left - margin.right;
    const height = 350 - margin.top - margin.bottom;

    function decimalFormatter(num, digit) {
      const si = [
        { value: 1, symbol: '' },
        { value: 1E3, symbol: 'K' },
        { value: 1E6, symbol: 'M' },
        { value: 1E9, symbol: 'B' }
      ];
      let i;
      for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
          break;
        }
      }
      return (num / si[i].value).toFixed(digit) + si[i].symbol;
    }

    const x = d3.scaleBand()
      .domain(this.data.map(d => d.month))
      .rangeRound([margin.left, width - margin.right])
      .padding(0.1);
    const tooltip = d3.select('#my_dataviz').append('div')
      .style('opacity', 0)
      .attr('class', 'tooltip')
      .style('background-color', 'white')
      .style('color','black')
      .style('border', 'solid')
      .style('border-width', '2px')
      .style('border-radius', '5px')
      .style('padding', '5px');

    // const tooltip1 = d3.select('#my_dataviz').append('div')
    // .style('opacity', 0)
    // .attr('class', 'tooltip')
    // .style('background-color', 'white')
    // .style('border', 'solid')
    // .style('border-width', '2px')
    // .style('border-radius', '5px')
    // .style('padding', '5px');


    const y1 = d3.scaleLinear()
      .domain([0, d3.max(this.data, d => d.benefit)])
      .rangeRound([height - margin.bottom, margin.top]);

    const y2 = d3.scaleLinear()
      .domain(d3.extent(this.data, d => d.cumubenefit))
      .rangeRound([height - margin.bottom, margin.top]);

    const xAxis = g => g
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(x));


    const y1Axis = g => g
      .attr('transform', `translate(${margin.left},0)`)
      .style('color', 'black')
      .call(d3.axisLeft(y1).tickFormat((d) => '$' + (decimalFormatter(d, 1))))
      .call(g => g.select('.domain'))
      .call(g => g.append('text')
        .attr('x', -margin.left)
        .attr('y', 10)
        .attr('fill', 'black')
        .attr('text-anchor', 'start')
        .text('Benefits ($)'));

    const y2Axis = g => g
      .attr('transform', `translate(${width - margin.right},0)`)
      .call(d3.axisRight(y2).tickFormat((d) => '$' + (decimalFormatter(d, 1))))
      .call(g => g.select('.domain'))
      .call(g => g.append('text')
        .attr('x', margin.right)
        .attr('y', 10)
        .attr('fill', 'black')
        .attr('text-anchor', 'end')
        .text('Cumulative Benefits ($)'));

    const line = d3.line()
      .x(d => x(d.month) + x.bandwidth() / 2)
      .y(d => y2(d.cumubenefit));


    const svg = d3.select('#my_dataviz')
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform',
        'translate(' + margin.left + ',' + margin.top + ')');

    svg.append('g')
      .attr('fill', '#00BCD6')
      .attr('fill-opacity', 0.8)
      .selectAll('rect')
      .data(this.data)
      .join('rect')
      .attr('x', d => x(d.month))
      .attr('width', x.bandwidth())
      .attr('y', d => y1(d.benefit))
      .attr('height', d => y1(0) - y1(d.benefit))
      .on('mouseover', function () {
        tooltip.style('opacity', 1);
        tooltip.style('display', 'block');
        d3.select(this)
          .style('opacity', 1);
      })
      .on('mousemove', function (d) {
        tooltip.transition()
          .duration(200)
          .style('opacity', 1)

        tooltip.html(`<div class="row"><div class="col">Month: ${d.month}</div></div>
        <div class="row"><div class="col">Benefit : $ ${decimalFormatter(d.benefit, 1)}</div></div>
        <div class="row"><div class="col">Application Count: ${d.appCount}</div></div>`)
          .style('left', d3.mouse(this)[0] + 250 + 'px')
          .style('top', d3.mouse(this)[1] - 50 + 'px')
      })
      .on('mouseout', function () { tooltip.style('display', 'none'); });


    svg.append('path')
      .attr('fill', 'none')
      .attr('stroke', 'currentColor')
      .attr('stroke-miterlimit', 1)
      .attr('stroke-width', 3)
      .attr('d', line(this.data));

    svg.selectAll('line-circle')
      .data(this.data)
      .enter()
      .append('circle')
      .attr('class', 'data-circle')
      .attr('r', 5)
      .attr('cx', (d) => x(d.month) + (x.bandwidth() / 2))
      .attr('cy', (d) => y2(d.cumubenefit))
      .attr('fill', 'red')
      .on('mouseover', function (d) {
        tooltip.style('display', 'block');
        tooltip.transition()
          .duration(200)
          .style('opacity', 1);
        tooltip.html(`<div class="row"><div class="col">Month: ${d.month}</div></div>
        <div class="row"><div class="col">Cumulative Benefit : $ ${decimalFormatter(d.cumubenefit, 1)}</div></div>`)
          .style('left', d3.mouse(this)[0] + 250 + 'px')
          .style('top', d3.mouse(this)[1] - 30 + 'px');
      })
      .on('mousemove', function (d) {
        tooltip.style('display', 'block');
        tooltip.transition()
          .duration(200)
          .style('opacity', 1);
        tooltip.html(`<div class="row"><div class="col">Month: ${d.month}</div></div>
        <div class="row"><div class="col">Cumulative Benefit : $ ${decimalFormatter(d.cumubenefit, 1)}</div></div>`)
          .style('left', d3.mouse(this)[0] + 250 + 'px')
          .style('top', d3.mouse(this)[1] - 30 + 'px');
      })
      .on('mouseout', () => {
        tooltip
          .style('opacity', 0);
        tooltip.style('display', 'none');
      });


    // svg.selectAll('rect')
    //   .data(this.data)
    //   .enter()
    //   .append('rect')
    //   .attr('class', 'data-rect')
    //   .attr('x', d => x(d.month))

    //   .attr('y', d => y1(d.benefit))

    //   .on("mouseover", function (d) {
    //     tooltip.transition()
    //       .duration(200)
    //       .style("opacity", 1);
    //     tooltip.html("<p> Month: " + d.month + "</p> <p>Cumulative Benefit:" + d.benefit + "</p>")
    //       .style("left", d3.mouse(this)[0] + 30 + "px")
    //       .style("top", d3.mouse(this)[1] - 80 + "px");
    //   })
    //   .on('mouseleave',  function() {
    //     tooltip
    //       .style('opacity', 0);
    //   });



    //     svg.append("g")
    //       .attr("fill", "none")
    //       .attr("pointer-events", "all")
    //       .selectAll("rect")
    //       .data(this.data)
    //       .join("rect")
    //       .attr("x", d => x(d.month))
    //       .attr("width", x.bandwidth())
    //       .attr("y", 0)
    //       .attr("height", height)
    //       .append("title")
    //       .text(d => `${d.month}
    // ${d.benefit.toLocaleString("en")} Benefit
    // ${d.cumubenefit.toLocaleString("en")} Cummulative Benefit`);

    svg.append('g')
      .call(xAxis);

    svg.append('g')
      .call(y1Axis);

    svg.append('g')
      .call(y2Axis);

    // svg.append("text")
    //   .attr("transform", "rotate(-90)")
    //   .attr("y", 0 - margin.left)
    //   .attr("x", 0 - (height / 2))
    //   .attr("dy", "1em")
    //   .style("text-anchor", "middle")
    //   .text("Benefit ($)");

  }


}
